var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconArrowArcRight = function SvgIconArrowArcRight(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M22.365 7.884a1 1 0 1 0-2 0v3.586l-1.292-1.293A10 10 0 0 0 2 17.25a1 1 0 0 0 2 0 8 8 0 0 1 13.658-5.659l1.293 1.293h-3.586a1 1 0 1 0 0 2h6a1 1 0 0 0 1-1.028z"
  })));
};
export default SvgIconArrowArcRight;